import { node, text } from "~/util/dom";

export default class ParamsItemPubtSelect {
	_container: HTMLDivElement;

	_items: Array<HTMLInputElement>;

	_item: any;

	// TODO: otypovat item
	constructor(item: any) {
		this._item = item;
		this._items = [];
		this._container = node("div");

		this._build();
	}

	// eslint-disable-next-line class-methods-use-this
	destroy() {
	}

	get input() {
		return this._container;
	}

	set state(val) {
		this._items.forEach(item => {
			if (parseInt(item.value) === val) {
				item.checked = true;
			}
		});
	}

	get state() {
		let criterion = 200;

		this._items.forEach(item => {
			if (item.checked) {
				criterion = parseInt(item.value);
			}
		});

		return criterion;
	}

	_build() {
		this._item.items.forEach(item => {
			const label = node("label", { className: "pubtSelect" });
			const radio = node("input", { type: "radio", value: item.value, checked: item.checked, name: "pubtSelect" });

			label.append(radio, text(item.label));
			this._container.append(label);

			radio.addEventListener("input", () => {
				const event = new CustomEvent("params-pubtselect-change");

				this._container.dispatchEvent(event);
				Mapy.getComponent("history").save();
			}, false);

			this._items.push(radio);
		});
	}
}
